import * as aTypes from 'Flow2/components/AdvancedBox/AdvancedConfig/AdvancedTypes';

export const isLocal = () => {
    if (window.location.origin === aTypes.LOCAL_HOST) {
        return true;
    }
    return false;
}

export const getBaseName = () => {
    let baseName = "";
    if (process.env.REACT_APP_BASENAME) {
        baseName = process.env.REACT_APP_BASENAME;
    }
    if (isLocal()) baseName = "/";
    return baseName;
}

export const pubPath = () => {
    let baseName = getBaseName();
    if (baseName === "/") return "";
    return baseName;
}